<template>
  <v-container fluid>
    <v-toolbar flat color="white" class="elevation-1">
      <v-toolbar-title>{{ this.$route.meta.title }} / Detalles</v-toolbar-title>
      <v-divider class="mx-4" inset vertical></v-divider>
      <div class="flex-grow-1"></div>
    </v-toolbar>
    
    {{ this.$route.params.id }}
  </v-container>
</template>
<script>
  import { mapGetters, mapMutations, mapState, mapActions } from "vuex"
  import HTTP from "@/http"

  export default {
    name: "DespachoPlanificados",
    components: {},

    data() {
      return {
        loading: false,
        consolidado: undefined
      }
    },

    mounted() {
      this.getData()
    },

    methods: {

      async getData() {
        let id = this.$route.params.id;

        this.loading = true;

        let response = await HTTP().get(`/consolidados-diarios/${id}`);
       
        this.loading = false

        console.log(response.data.data);

        
      }
    }


  }
</script>